import { render } from "./GroupForm.vue?vue&type=template&id=4e45ab55&ts=true"
import script from "./GroupForm.vue?vue&type=script&lang=ts"
export * from "./GroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__